"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_lilnoundersDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nounsDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "lilnoundersDAO",
                type: "address",
            },
        ],
        name: "LilNoundersDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "NounBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "NounCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "nounsDAO",
                type: "address",
            },
        ],
        name: "NounsDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lilnoundersDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract INounsSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "accessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "glasses",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lilnoundersDAO",
                type: "address",
            },
        ],
        name: "setLilNoundersDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_nounsDAO",
                type: "address",
            },
        ],
        name: "setNounsDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_lilnoundersDAO, _nounsDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_lilnoundersDAO, _nounsDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_lilnoundersDAO, _nounsDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_lilnoundersDAO, _nounsDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsToken__factory = NounsToken__factory;
NounsToken__factory.bytecode = _bytecode;
NounsToken__factory.abi = _abi;
